import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, OnInit, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Dropdown } from '@shared/components/dropdown/model/dropdown';
import { IconsDirective } from '@shared/directives';

@Component({
  selector: 'app-search',
  styleUrl: './search.component.scss',
  templateUrl: './search.component.html',
  imports: [IconsDirective, FormsModule, NgStyle],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchComponent implements OnInit {
  readonly items = input<Dropdown[]>();
  readonly suggestion = input<Dropdown | null>();
  readonly value = input<string | undefined>('');
  readonly placeholder = input('');
  readonly customStyle = input<{
    [klass: string]: string | number;
  }>({});
  readonly suggestionClick = output();
  readonly valueInput = output<string>();
  readonly searchItems = output<Dropdown[]>();
  readonly resetClick = output();

  previousValue = signal<string>(null!);

  ngOnInit(): void {
    this.previousValue.set(this.value() ?? '');
  }

  onSearch(value: string) {
    const items = this.items();
    if (items) {
      this.searchItems.emit(items.filter((item) => item.label.toLowerCase().includes(value.toLowerCase())));
    }
  }

  onReset(searchInputElement: HTMLInputElement) {
    searchInputElement.value = '';
    this.valueInput.emit('');
    this.resetClick.emit();
    this.onSearch('');
  }

  onChange(val: Event): void {
    const value = (val.target as HTMLInputElement).value;
    if (this.previousValue() !== value) {
      this.valueInput.emit(value);
      this.previousValue.set(value);
      this.onSearch(value);
    }
  }
}
